exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ticket-event-style {\r\n    word-break: break-all;\r\n    padding-left : 20px;\r\n    margin : 5px 0;\r\n    padding-right: 20px;\n}\n.ticket_event_0 {\r\n    padding : 5px 0;\r\n    border-bottom: 2px solid #f5f6fb;\n}\n.private_ticket_event {\r\n    background: #f0f3f5;\r\n    border-top-color: white!important;\n}\n.ticket_event_0:hover {\r\n    -webkit-box-shadow: 1px 1px 5px 2px #c4c4c4;\r\n            box-shadow: 1px 1px 5px 2px #c4c4c4;\n}\n.ticket-reply-switch-bar {\r\n    margin-bottom: 30px;\n}\n.el-divider {\r\n    background-color: #f5f6fb;\n}\n.el-divider--horizontal {\r\n    height: 2px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e0ab5dce","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketEventList.vue
// module id = 799
// module chunks = 75